/**
 * Shared request helpers for the TPM pages. The TPM endpoints are guarded by
 * protectAuthenticatedAccount on the server and scope every query to the
 * authenticated account, so the client only has to send its Basic credentials.
 */

export function getStoredUser() {
    try {
        return JSON.parse(localStorage.getItem('user'));
    } catch (_error) {
        return null;
    }
}

export function getSessionHeaders(user) {
    return {
        'Content-Type': 'application/json',
        Authorization: `Basic ${user.authdata || ''}`
    };
}

/** Reads a response body as JSON, turning a non-2xx into a rejected promise. */
export function readJsonResponse(response) {
    return response.text().then(text => {
        let body = {};
        try {
            body = text ? JSON.parse(text) : {};
        } catch (_error) {
            body = {};
        }
        if (!response.ok) throw new Error(body.error || body.message || 'Request failed.');
        return body;
    });
}
